import { combineReducers } from "redux";

import authReducer from "./authReducer";
import userReducer from "./userReducer";
import langReducer from "./langReducer";
import snackbarReducer from "./snackbarReducer";
import brandReducer from "./brandReducer";

import locationReducer from "./locationReducer";

import summerPointsReducer from "./summerPointsReducer";
import winterPointsReducer from "./winterPointsReducer";

const rootReducer = combineReducers({
  auth: authReducer,
  user: userReducer,
  i18n: langReducer,
  snackbar: snackbarReducer,
  brand: brandReducer,

  location: locationReducer,
  processPoint: summerPointsReducer,
  winterPoints: winterPointsReducer,
});

export default rootReducer;
